

import { API_USER_URL } from "@/env";
import { homeUrl } from "@/pages/Auth/routeConfig";
import { message } from "antd";


const API_USE = API_USER_URL || '';

const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};


async function loginUser(email: string, password: string) {
    try {
        const res = await fetch(API_USER_URL + '/api/v1/be/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: email,
                password: password,
            }),
        });
        const data = await res.json();

        if (data.error && data.error.needs_verification) {
            message.info('Your account needs verification. Sending verification code to your email.');
            window.location.href = `/verify-otp?uid=${data.error.user_id}&reactive=true`;
            return;
        }
        if (data.error) {
            if (data.error.password_wrong) {
                message.error('Incorrect password, please try again!');
                return;
            }
            message.error(data.error.message || 'Login failed, please try again!');
            return;
        }
        if (res.status) {
            localStorage.setItem('token', data.data.access_token);
            localStorage.setItem('user', JSON.stringify(data.data.info));
            // localStorage.setItem('user', JSON.stringify(res.data.info));
            const res2 = await fetch(API_USER_URL + `/api/v1/be/users/${data.data.info.id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${data.data.access_token}`,
                },
            })
            // const res2 = await getUserInfo(data.data.info.id);
            const res2Data = await res2.json();

            if (res2Data.status) {
                localStorage.setItem('user', JSON.stringify(res2Data.data))

                message.success('Login successful!');
                if (res2Data.data.roles_display.includes('Admin')) {
                    window.location.href = '/admin/dashboard'; // Redirect to admin dashboard
                    return;
                }
                window.location.href = homeUrl; // Redirect to home page
            }

            // message.success('Login successful!');
            window.location.href = homeUrl; // Redirect to accounts overview page
            return;
        }
        else if (data.status === false && data.error && data.error.needs_verification) {
            message.info('Your account needs verification. Sending verification code to your email.');
            const resOtp = await fetch(API_USER_URL + '/api/v1/be/request-verification', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email,
                    password: password,
                }),
            });
            const resOtpData = await resOtp.json();
            if (resOtpData.status) {
                message.success('Verification code sent to your email. Please check your inbox.');
            } else {
                message.error(resOtpData.message || 'Failed to send verification code, please try again!');
                return;
            }
            window.location.href = `/verify-otp?uid=${data.error.user_id}&reactive=true`;

        } else if (data.status === false && data.error && data.error.password_wrong) {
            message.error('Incorrect password, please try again!');
            return;
        }
        else {
            message.error('Login failed, please try again!');
            return;
        }
    }
    catch (error) {
        console.error('Login error:', error);
        message.error('Login failed, please try again!' + JSON.stringify(error));
    }
}

async function signUpUser(email: string, password: string, confirmPassword: string, reffralCode?: string): Promise<any> {
    try {
        const send_data = {
            email: email,
            password: password,
            password_confirmation: confirmPassword,
        }
        const res = await fetch(API_USER_URL + '/api/v1/be/sign-up', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(
                reffralCode ? { ...send_data, referral_code: reffralCode } : send_data
            ),
        });
        const resData = await res.json();

        if (res.status) {
            localStorage.setItem('token', resData.data.token);
            message.success('Registration successful! Please check your email to verify your account');
            return resData.data.user;
        } else {
            message.error(resData.message || 'Registration failed, please try again!');
            return;
        }
    } catch (error) {
        console.error('Registration error:', error);
        message.error('Registration failed, please try again!' + JSON.stringify(error));
    }

}


async function submitResetPasswordEmail(email: string) {
    try {
        const res = await fetch(API_USER_URL + '/api/v1/be/password/forget-password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
        });
        const data = await res.json();
        if (data.status) {
            message.success("Password reset email sent. Please check your email.");
            return true;
        }
        else {
            message.error("Error resetting password. Please try again. Error:" + data.message);
            return false;
        }
    }
    catch (error) {
        message.error("Error resetting password. Please try again. Error:" + error);
        return false;
    }
}

async function submitResendOTP(email: string) {
    try {
        const res = await fetch(API_USER_URL + '/api/v1/be/password/resend-forget-password-otp', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
        });
        const data = await res.json();
        if (data.status) {
            message.success("OTP resent successfully. Please check your email.");
        }
        else {
            message.error("Error resending OTP. Please try again. Error:" + data.message);
        }
    }
    catch (error) {
        message.error("Error resending OTP. Please try again. Error:" + error);
    }
}

async function submitVerifyOTP(email: string, otpValue: string) {
    try {
        const res = await fetch(API_USER_URL + '/api/v1/be/password/verify-reset-password-otp', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email: email, otp: otpValue }),
        });
        const data = await res.json();
        if (data.status) {
            message.success("OTP verified successfully. Please enter your new password.");
            return data.reset_token;
        }
        else {
            message.error("Error verifying OTP. Please try again. Error:" + data.message);
        }
    }
    catch (error) {
        message.error("Error verifying OTP. Please try again. Error:" + error);
    }
}

async function submitReset(email: string, resetToken: string, password: string, confirmPassword: string) {
    try {
        const res = await fetch(API_USER_URL + '/api/v1/be/password/reset-password-otp', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: email,
                reset_token: resetToken,
                password: password,
                password_confirmation: confirmPassword
            }),
        });
        const data = await res.json();
        if (data.status) {
            message.success("Password reset successful. Redirecting to login page in 3 seconds...");
            setTimeout(() => {
                window.location.href = '/login';
            }, 3000);
        }
        else {
            message.error("Error resetting password. Please try again. Error:" + data.message);
        }
    }
    catch (error) {
        message.error("Error resetting password. Please try again. Error:" + error);
    }
}

async function checkRefCodeExists(referralCode: string): Promise<boolean> {
    try {
        const res = await fetch(API_USER_URL + `/api/v1/be/referral/check-code`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ code: referralCode }),
        });
        const data = await res.json();
        if (data.status) {
            return true;
        }
        else {
            message.error("Error checking referral code. Please try again. Error:" + data.message);
            return false;
        }
    }
    catch (error) {
        message.error("Error checking referral code. Please try again. Error:" + error);
        return false;
    }
}


async function verifyOtp(otp: string, uid: string | null) {
    try {
        if (!uid) {
            message.error('User ID is missing!');
            return;
        }
        if (otp.length !== 6) {
            message.error('Please enter a valid 6-digit OTP code!');
            return;
        }

        const res = await fetch(API_USE + '/api/v1/be/verify-email-otp', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                user_id: uid,
                otp: otp
            }),
        });
        const data = await res.json();

        if (data.status) {
            message.success('OTP verified successfully!');
            return;
        } else {
            message.error(data.message || 'OTP verification failed, please try again!');
        }
    }
    catch (error) {
        message.error('OTP verification failed, please try again!');
    }
}

function checkPasswordStrength(password: string): boolean {
    // At least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
}

function checkConfirmPassword(password: string, confirmPassword: string): boolean {
    return password === confirmPassword;
}


export {
    signUpUser,
    checkPasswordStrength,
    checkConfirmPassword,
    loginUser,
    checkRefCodeExists,
    submitResetPasswordEmail,
    submitResendOTP,
    submitVerifyOTP,
    submitReset,
    verifyOtp
};